<p-panel header="Facility Contact Information">
  <p class="mb-4 font-semibold">{{ providerAccount.providerName }}</p>

  <p-table [value]="contactInfo" [columns]="contactInfoColumns" data-test-id="contact-info-table">
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th>
            {{ col.header }}
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-facilityInfo let-columns="columns">
      <tr>
        @for (col of columns; track col) {
          <td>
            @switch (col.field) {
              @case ('zipCode') {
                {{ facilityInfo[col.field] | zipCode }}
              }
              @default {
                {{ facilityInfo[col.field] }}
              }
            }
          </td>
        }
      </tr>
    </ng-template>
  </p-table>

  <p class="mb-1 mt-4 font-semibold">Location Information</p>
  <div class="p-form-widget p-form-view-data p-form-aligned">
    <div class="field">
      <label>Phone:</label>
      <div class="p-field-value">
        <div class="readonly-field">{{ providerAccount.locationPhone | phoneNumber }}</div>
      </div>
    </div>
    <div class="field">
      <label>Fax:</label>
      <div class="p-field-value">
        <div class="readonly-field">{{ providerAccount.locationFax | phoneNumber }}</div>
      </div>
    </div>
    <div class="field">
      <label>Fax Confirmed?</label>
      <div class="p-field-value">
        <div class="readonly-field">
          <p-checkbox
            [binary]="true"
            [disabled]="true"
            data-test-id="fax-conrfirmed-checkbox"
            [ngModel]="providerAccount.locationFaxConfirmed"
            >
          </p-checkbox>
        </div>
      </div>
    </div>
    <div class="field">
      <label>Fax Confirmed Date:</label>
      <div class="p-field-value">
        <div class="">{{ providerAccount.faxConfirmedDate | date: 'MM/dd/yyyy' | emptyPlaceholder }}</div>
      </div>
    </div>
  </div>
</p-panel>
